// extracted by mini-css-extract-plugin
module.exports = {"content":"Portfolio_content__DrhnD"};